import { SYS_ADMIN_ROLE } from '@/assets/common/roles';
import socialMediaConfig from '@/assets/common/social-media-config';

const items = [
    {
        text: 'Custom Inboxes',
        iconPrefix: 'custom-inboxes',
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox 1'
                    },
                    {
                        name: 'inbox 2'
                    },
                    {
                        name: 'inbox 3'
                    }
                ],
                editable: true,
                pinnable: true,
                flowMode: true,
                duplicatable: true,
                deletable: true,
                showMoreDivider: 15
            }
        ],
        color: '#16D7AC',
        assignedToMeOption: true,
        alwaysVisible: true
    },
    {
        text: 'Labels',
        iconPrefix: 'labels',
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'labels',
                addPossibility: true,
                modalPath: 'labels/AddEditModal',
                items: [
                    {
                        name: 'label 1'
                    },
                    {
                        name: 'label 2'
                    },
                    {
                        name: 'label 3'
                    }
                ],
                editable: true,
                pinnable: true,
                flowMode: true,
                deletable: true,
                showMoreDivider: 15
            }
        ],
        color: '#00A582',
        alwaysVisible: true
    },
    {
        text: 'Twitter',
        social_type: socialMediaConfig.twitter.id,
        iconPrefix: 'twitter',
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        // *: https://developer.twitter.com/en/docs/twitter-api/v1/data-dictionary/object-model/tweet
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'this is very long inbox name hello ok no thanks'
                    },
                    {
                        name: 'singleWordInboxHereOkayLoremIpsumSetDolorOkLoremOkIpsum'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'dms',
                items: [
                    {
                        name: '@test1234'
                    },
                    {
                        name: '@wpz5'
                    }
                ]
            },
            {
                text: 'timelines',
                addPossibility: true,
                modalPath: 'twitter/AddEditTimelineStreamModal',
                items: [
                    {
                        name: 'Elon Musk stream',
                        handle: '@elonmusk',
                        entityType: 2,
                        entityIds: [10],
                        isAuthenticated: true
                    },
                    {
                        name: '@Valve',
                        handle: '@valvesoftware',
                        entityType: 2,
                        entityIds: [10],
                        isAuthenticated: false
                    }
                ],
                editable: {
                    where: {
                        isAuthenticated: {
                            value: false
                        }
                    }
                },
                pinnable: true,
                deletable: true
            },
            {
                text: 'streams',
                addPossibility: true,
                modalPath: 'twitter/add-edit-stream/Modal',
                items: [
                    {
                        name: 'stream1',
                        searchPhrase: 'wix',
                        ignorePhrase: 'dl',
                        relatedHandles: ['wix-br', 'wix-jp'],
                        language: 'pl',
                        locations: ['1'],
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10],
                        isAuthenticated: false
                    }
                ],
                editable: {
                    where: {
                        isAuthenticated: {
                            value: false
                        }
                    }
                },
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.twitter.color
    },
    {
        text: 'Instagram',
        iconPrefix: 'ig',
        social_type: socialMediaConfig.instagram.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'dms',
                items: [
                    {
                        name: '@test1234'
                    },
                    {
                        name: '@wpz5'
                    }
                ]
            },
            {
                text: 'your pages',
                items: [
                    {
                        name: 'tes1234 Page',
                        subItems: [
                            {
                                name: 'tes1234 :: Ad Comments'
                            },
                            {
                                name: 'tes1234 :: My Posts'
                            },
                            {
                                name: 'tes1234 :: Ads'
                            },
                            {
                                name: 'tes1234 :: Mentions'
                            },
                            {
                                name: 'tes1234 :: Replies'
                            }
                        ]
                    }
                ]
            },
            {
                text: 'instagram pages',
                addPossibility: true,
                modalPath: 'instagram/AddEditStreamModal',
                items: [
                    {
                        name: 'test1',
                        businessName: 'account012',
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false
            },
            {
                text: 'instagram hashtags',
                addPossibility: true,
                modalPath: 'instagram/AddEditStreamModal',
                items: [
                    {
                        name: '#account012',
                        searchPostsByHashtags: '#account012, #acc00, #awesome',
                        match: 'good',
                        ignore: 'bad',
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.instagram.color
    },
    {
        text: 'Etoro',
        iconPrefix: 'etoro',
        social_type: socialMediaConfig.etoro.id,
        sortButtons: [
            { text: 'Karma', value: 'karma' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'ETORO STREAMS',
                items: [
                    {
                        name: 'Stream 1'
                    },
                    {
                        name: 'Stream 2'
                    }
                ]
            }
        ],
        color: socialMediaConfig.etoro.color
    },
    {
        text: 'Facebook',
        iconPrefix: 'fb',
        social_type: socialMediaConfig.facebook.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'facebook messenger',
                items: [
                    {
                        name: '@AffogataTeam'
                    },
                    {
                        name: '@Community'
                    },
                    {
                        name: '@WhiteRabbit'
                    },
                    {
                        name: '@something'
                    },
                    {
                        name: '@affogataDevs'
                    }
                ]
            },
            {
                text: 'your pages & groups',
                items: [
                    {
                        name: 'rabbitsBlog Page',
                        subItems: [
                            {
                                name: 'rabbitsBlog :: Ad Comments'
                            },
                            {
                                name: 'rabbitsBlog :: My Posts'
                            },
                            {
                                name: 'rabbitsBlog :: Ads'
                            },
                            {
                                name: 'rabbitsBlog :: Mentions'
                            },
                            {
                                name: 'rabbitsBlog :: Replies'
                            }
                        ]
                    }
                ]
            },
            {
                text: 'facebook pages',
                addPossibility: true,
                modalPath: 'facebook/AddEditStreamModal',
                items: [
                    {
                        name: 'Page 1',
                        pageName: 'Shopify',
                        entityType: 2,
                        entityIds: [10],
                        subItems: [
                            {
                                name: 'Page 1 :: Posts',
                                isPostSubItem: true
                            },
                            {
                                name: 'Page 1 :: Comments'
                            }
                        ]
                    },
                    {
                        name: 'stream 0999',
                        pageName: 'Spotify',
                        entityType: 2,
                        entityIds: [10],
                        subItems: [
                            {
                                name: 'stream 0999 :: Posts',
                                isPostSubItem: true
                            },
                            {
                                name: 'stream 0999 :: Comments'
                            }
                        ]
                    }
                ],
                editable: {
                    where: {
                        isPostSubItem: {
                            value: true
                        }
                    }
                },
                pinnable: {
                    where: {
                        isPostSubItem: {
                            value: true
                        }
                    }
                },
                deletable: {
                    where: {
                        isPostSubItem: {
                            value: true
                        }
                    }
                },
                duplicatable: false
            }
        ],
        color: socialMediaConfig.facebook.color
    },
    {
        text: 'Reddit',
        iconPrefix: 'reddit',
        social_type: socialMediaConfig.reddit.id,
        sortButtons: [
            { text: 'Karma', value: 'karma' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'reddit streams',
                addPossibility: true,
                modalPath: 'reddit/add-edit-stream/Modal',
                items: [
                    {
                        name: 'NSO Group',
                        searchPhrase: 'wixhelp',
                        matchPhrase: 'example',
                        ignorePhrase: 'new',
                        subredditsToAdd: ['r/SEO'],
                        subredditsToExclude: [],
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.reddit.color
    },
    {
        text: 'Youtube',
        iconPrefix: 'yt',
        social_type: socialMediaConfig.youtube.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'search streams',
                addPossibility: true,
                modalPath: 'youtube/AddEditRegularStreamModal',
                items: [
                    {
                        name: 'wow',
                        searchPhrase: 'wow',
                        matchPhrase: 'wow video',
                        ignorePhrase: 'new',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            },
            {
                text: 'channel streams',
                addPossibility: true,
                modalPath: 'youtube/AddEditChannelStreamModal',
                items: [
                    {
                        name: 'Node',
                        subItems: [
                            {
                                name: 'Node :: Videos',
                                isVideosItem: true,
                                channelUrl: 'https://www.youtube.com/channel/UCI4Wh0EQPjGx2jJLjmTsFBQ',
                                isLeadsStreamChecked: true,
                                entityType: 2,
                                entityIds: [10]
                            },
                            {
                                name: 'Node :: Videos Comments',
                                channelUrl: 'https://www.youtube.com/channel/UCI4Wh0EQPjGx2jJLjmTsFBQ',
                                isLeadsStreamChecked: true,
                                entityType: 2,
                                entityIds: [10]
                            }
                        ]
                    },
                    {
                        name: 'Kurzgesagt',
                        subItems: [
                            {
                                name: 'Kurzgesagt :: Videos',
                                isVideosItem: true,
                                isLeadsStreamChecked: false,
                                entityType: 2,
                                entityIds: [10]
                            },
                            {
                                name: 'Kurzgesagt :: Videos Comments',
                                isLeadsStreamChecked: false,
                                entityType: 2,
                                entityIds: [10]
                            }
                        ]
                    }
                ],
                editable: {
                    where: {
                        isVideosItem: {
                            value: true
                        }
                    }
                },
                pinnable: {
                    where: {
                        isVideosItem: {
                            value: true
                        }
                    }
                },
                deletable: {
                    where: {
                        isVideosItem: {
                            value: true
                        }
                    }
                },
                duplicatable: false
            }
        ],
        color: socialMediaConfig.youtube.color
    },
    {
        text: 'Linkedin',
        iconPrefix: 'linkedin',
        social_type: socialMediaConfig.linkedin.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'your feed',
                items: [
                    {
                        name: 'tes1234',
                        subItems: [
                            {
                                name: 'tes1234 :: Comments'
                            },
                            {
                                name: 'tes1234 :: Feed'
                            }
                        ]
                    }
                ]
            }
        ],
        color: socialMediaConfig.linkedin.color
    },
    {
        text: 'Articles',
        iconPrefix: 'articles',
        social_type: socialMediaConfig.article.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true,
                flowMode: true
            },
            {
                text: 'article streams',
                addPossibility: true,
                modalPath: 'articles/add-edit-stream/Modal',
                items: [
                    {
                        name: 'test1 (Google Alerts)',
                        type: 'google',
                        rssUrls: ['someUrl1', 'someUrl2', 'someUrl3'],
                        isLeadsStreamChecked: false,
                        entityType: 2,
                        entityIds: [10]
                    },
                    {
                        name: 'test2 (Webhose)',
                        type: 'webhose',
                        phrasesToSearch: 'great awesome',
                        phrasesToHighlight: 'wow absolutely nice',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.article.color
    },
    {
        text: 'Reviews & Forums',
        iconPrefix: 'reviews-forums',
        social_type: socialMediaConfig.webreview.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false,
                flowMode: true
            },
            {
                text: 'ios review streams',
                addPossibility: true,
                modalPath: 'reviews-and-forums/AddEditAppstoreStreamModal',
                items: [
                    {
                        name: 'whatsapp',
                        appName: 'WhatsApp Business',
                        appId: '386412985',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false
            },
            {
                text: 'trustpilot',
                addPossibility: true,
                iconPrefix: 'tp',
                social_type: socialMediaConfig.trustpilot.id,
                modalPath: 'reviews-and-forums/AddEditTrustpilotStreamModal',
                items: [
                    {
                        name: 'etoro.nl',
                        businessName: 'etoro.nl',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false
            },
            {
                text: 'google play',
                addPossibility: true,
                social_type: socialMediaConfig.googlePlay.id,
                modalPath: 'reviews-and-forums/AddEditGooglePlayStreamModal',
                items: [
                    {
                        name: 'whatsapp',
                        packageName: 'com.whatsapp',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false
            },
            {
                text: 'web reviews',
                addPossibility: true,
                social_type: socialMediaConfig.webreview.id,
                modalPath: 'reviews-and-forums/add-edit-web-reviews-stream/Modal',
                items: [
                    {
                        name: 'whatsapp phone reviews',
                        searchPhrase: 'whatsapp',
                        phrasesToHighlight: ['phone'],
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.webreview.color
    },
    {
        text: 'Wix Answers',
        iconPrefix: 'wix-answers',
        social_type: socialMediaConfig.wixan.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false,
                flowMode: true
            },
            {
                text: 'your services',
                items: [
                    {
                        name: 'service test',
                        subItems: [
                            {
                                name: 'service test :: Replies'
                            },
                            {
                                name: 'service test :: Tickets'
                            }
                        ]
                    }
                ]
            }
        ],
        color: socialMediaConfig.wixan.color,
        roles: [SYS_ADMIN_ROLE]
    },
    {
        text: 'Tiktok',
        iconPrefix: 'tiktok',
        social_type: socialMediaConfig.tiktok.id,
        sortButtons: [
            { text: 'Followers', value: 'followers' },
            { text: 'Date', value: 'date' }
        ],
        categories: [
            {
                text: 'inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: false,
                flowMode: true
            },
            {
                text: 'tiktok hashtags',
                addPossibility: true,
                modalPath: 'tiktok/AddEditStreamModal',
                items: [
                    {
                        name: 'anime',
                        hashtag: 'anime',
                        isLeadsStreamChecked: false,
                        entityType: 2,
                        entityIds: [10]
                    },
                    {
                        name: 'creative',
                        hashtag: 'creative',
                        isLeadsStreamChecked: true,
                        entityType: 2,
                        entityIds: [10]
                    }
                ],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.tiktok.color
    },
    {
        text: 'TEST1 (no streams)',
        iconPrefix: 'tiktok',
        social_type: socialMediaConfig.tiktok.id,
        categories: [
            {
                text: 'test1 inboxes',
                addPossibility: false,
                modalPath: 'common/AddEditInboxModal',
                items: [
                    {
                        name: 'inbox1'
                    },
                    {
                        name: 'inbox2'
                    },
                    {
                        name: 'inbox3'
                    }
                ],
                editable: false,
                pinnable: false,
                deletable: false,
                duplicatable: false,
                flowMode: false
            },
            {
                text: 'test1 hashtags',
                addPossibility: true,
                modalPath: 'tiktok/AddEditStreamModal',
                items: [],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.tiktok.color
    },
    {
        text: 'TEST2 (no streams & inboxes)',
        iconPrefix: 'tiktok',
        social_type: socialMediaConfig.tiktok.id,
        categories: [
            {
                text: 'test2 inboxes',
                addPossibility: true,
                modalPath: 'common/AddEditInboxModal',
                items: [],
                editable: false,
                pinnable: false,
                deletable: false,
                duplicatable: false,
                flowMode: false
            },
            {
                text: 'test2 hashtags',
                addPossibility: true,
                modalPath: 'tiktok/AddEditStreamModal',
                items: [],
                editable: true,
                pinnable: true,
                deletable: true,
                duplicatable: true
            }
        ],
        color: socialMediaConfig.tiktok.color
    }
];

export default items.map(item => {
    const categories = item.categories.map(category => {
        const categoryId = `${item.iconPrefix}-${category.text}`;

        // @TMP:temporary author assignment to all menu items
        const author = {
            firstName: 'Sys',
            lastName: 'Admin',
            id: '1',
            email: 'sys_admin@aff.test',
            role: '0'
        };

        const items = category.items?.map((categoryItem, itemIndex) => {
            const subItems =
                categoryItem.subItems?.map((categorySubItem, subItemIndex) => ({
                    ...categorySubItem,
                    author,
                    id: `${categoryId}-${itemIndex}-${subItemIndex}`
                })) || null;

            return {
                ...categoryItem,
                categoryId,
                id: `${categoryId}-${itemIndex}`,
                author,
                subItems
            };
        });

        return {
            ...category,
            items,
            id: categoryId
        };
    });

    return { ...item, categories };
});
